import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Tooltip } from '@mui/material';
import { memo, useMemo } from 'react';
import { getRfIcon } from './utils/rf-icons';
export const RFSignalIndicator = memo(function RFSignalIndicator(props) {
    const { dbm, is_433 } = props;
    const level = useMemo(() => (dbm == null ? 0 : dbm >= -70 ? 3 : dbm >= -80 ? 2 : dbm >= -90 ? 1 : 0), [dbm]);
    const str = useMemo(() => dbm != null
        ? `${dbm} дБм`
        : is_433
            ? 'Датчик подключен по радиоканалу 433МГц'
            : '', [dbm, is_433]);
    return (_jsx(Tooltip, { title: str, children: _jsx(Box, { display: "flex", alignItems: "center", fontSize: "inherit", color: "inherit", children: getRfIcon(level, !!is_433) }) }));
});
